import React from 'react';
import { Image } from '../../../../../wag-react/next-components/image';
import { WalkerOfferedServicesItem } from '../../../../../types/api';
import { capitalizeFirstLetter } from '../../../../OvernightServicePreferencesContainer/helpers';
import { serviceAssetMap } from '../assets';
import { formatPrice } from '../helpers/formatPrice';
import { Box } from '../../../../../wag-react/next-components/box';
import { Typography } from '../../../../../wag-react/components/Typography';
type Props = {
  serviceCategoryName: WalkerOfferedServicesItem['serviceCategory'];
  minPrice: WalkerOfferedServicesItem['price']['min'];
};
export const WalkerServiceCollapsibleTitle = ({
  serviceCategoryName,
  minPrice
}: Props) => <Box data-sentry-element="Box" data-sentry-component="WalkerServiceCollapsibleTitle" data-sentry-source-file="WalkerServiceCollapsibleTitle.tsx">
    <Box display="flex" alignItems="center" data-sentry-element="Box" data-sentry-source-file="WalkerServiceCollapsibleTitle.tsx">
      <Box display="flex" alignItems="center" justifyContent="center" width="24px" height="24px" mr="6px" data-sentry-element="Box" data-sentry-source-file="WalkerServiceCollapsibleTitle.tsx">

        <Image src={serviceAssetMap[serviceCategoryName.replace('-', '_')]?.icon} width={serviceCategoryName === 'walk' ? '13px' : '24px'} height={serviceCategoryName === 'walk' ? '21px' : '24px'} alt={serviceCategoryName} mr="10px" data-sentry-element="Image" data-sentry-source-file="WalkerServiceCollapsibleTitle.tsx" />
      </Box>

      <Typography variant="body1" fontFamily="muliBold" fontSize={['16px', '18px']} color="#272727" data-sentry-element="Typography" data-sentry-source-file="WalkerServiceCollapsibleTitle.tsx">
        {capitalizeFirstLetter(serviceCategoryName)}
      </Typography>
      <Typography color="#272727" m={0} variant="legal" ml={2} data-sentry-element="Typography" data-sentry-source-file="WalkerServiceCollapsibleTitle.tsx">
        From
        {' '}
        {formatPrice(minPrice)}
      </Typography>
    </Box>
  </Box>;